import { MainContents } from '@/components/MainContents';
import Loading from '@/components/Loading';

export function PdfImportProcessingStatus() {
  return (
    <MainContents>
      <div className="flex h-full min-h-[640px] flex-col items-center justify-center rounded-sm bg-white p-6 shadow-[0px_0px_2px_0px_rgba(0,0,0,0.2)]">
        <Loading size="small" />
        <p className="mt-2 text-sm text-gray-600">
          PDFから求人データを取り込み中です。しばらくお待ちください。
        </p>
      </div>
    </MainContents>
  );
}
